import React from 'react';
import {useMapMaterialDisplayName} from 'shared/components/Header/helper/useMapMaterialDisplayName';
import {useMinUsageInfo} from 'shared/components/Header/helper/useMinUsageInfo';
import {JobCost} from 'components/customer/Job/store/jobApi';
import {
    Item,
    ItemContainer,
    Row,
} from 'components/customer/Confirmation/Checkout/Table';
import {formatPrice} from 'shared/helpers';
import MinimumUsageMoreInfo from 'shared/components/Header/MinimumUsageMoreInfo';
import {MoreInfoStatic} from 'shared/components/MoreInfo/MoreInfo';

export const MinUsage = ({jobCost}: {jobCost?: JobCost | null}) => {
    const {mapMaterialDisplayName} = useMapMaterialDisplayName();
    const {moreInfoData} = useMinUsageInfo();

    if (jobCost?.totalMinUsage) {
        return (
            <Row>
                <td>
                    <ItemContainer>
                        <Item>Minimum usage Fee</Item>

                        <MoreInfoStatic
                            editbuttonVisible={false}
                            hoverText="Minimum Usage Fee"
                            dialogClassName="modal-md"
                            info={
                                <MinimumUsageMoreInfo
                                    minimumUsages={moreInfoData}
                                    mapMaterialDisplayName={
                                        mapMaterialDisplayName
                                    }
                                />
                            }
                        />
                    </ItemContainer>
                </td>
                <td>{formatPrice(jobCost?.totalMinUsage || 0, {})}</td>
                <td />
            </Row>
        );
    }
};
